import * as React from 'react'

import Portal from '@mui/material/Portal'
import Button from '@mui/material/Button'

type Props = {
  readonly: boolean
  onCancel: () => void
  onSubmit: () => void
  isSubmitting: boolean
  footerInstance: Element | null
}

export function Footer(props: Props) {
  const { readonly, onCancel, onSubmit, isSubmitting, footerInstance } = props

  return (
    <Portal container={footerInstance}>
      {readonly ? (
        <Button color="primary" variant="contained" onClick={onCancel}>
          Close
        </Button>
      ) : (
        <>
          <Button onClick={onCancel} variant="outlined">
            Cancel
          </Button>

          <Button
            color="primary"
            onClick={onSubmit}
            variant="contained"
            disabled={isSubmitting}
          >
            Submit
          </Button>
        </>
      )}
    </Portal>
  )
}
